<template>
    <button
        :type="buttonType"
        :disabled="isDisabled"
        class="flex justify-center items-center uppercase text-base font-gotham transition-all duration-300 ease-in"
    >
        <slot />
    </button>
</template>

<script>
    export default {
        props: {
            buttonType: {
                type: String,
                default: 'button',
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
